<template>
  <div id="app-index" ref="index">
    <web-header :searchStatus="0"></web-header>
    <carousel></carousel>
    <news :modelId="navData.news"></news>
    <activitys :modelId="navData.activity"></activitys>
    <volunteers :newsId="navData.fanbu"></volunteers>
    <!-- <maps></maps> -->
    <projects :modelId="navData.project"></projects>
    <videos  :modelId="navData.photo"></videos>
    <!-- <cooperator></cooperator> -->
    <WtFooter></WtFooter>
  </div>
</template>
<script>
import webHeader from "../Public/header";
import carousel from "./carousel";
import news from "./news";
import activitys from "./activitys";
import volunteers from "./volunteer";
// import maps from "./map";
import projects from "./projects";
import videos from "./videos";
// import cooperator from "./cooperator"
export default {
  components: {
    webHeader,
    carousel,
    news,
    activitys,
    volunteers,
    // maps,
    projects,
    videos,
    // cooperator
  },
  data() {
    return {
      navData: {},
      listyle: 1,
    };
  },
  mounted() {
    this.$db.post(this.$url.pageIndex.list).then(resp=>{
      if(resp && resp.data.length){
        this.navData = resp.data[0]
      }
    })
  },
};
</script>
<style lang="scss" scoped>
#app-index {
  width: 100%;
  background-color: #fff;
}
</style>

<style lang="scss" scoped>
#app-news {
  width: 100%;
  margin-bottom: 45px;
}
.news-box {
  max-width: 1300px;
  margin: 0 auto;
  .news-top {
    position: relative;
    padding-left: 18px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 45px;
    > span {
      width: 2px;
      // height: 55px;
      height: 100%;
      background-image: linear-gradient(
          0deg,
          #8ec31f 0%,
          #4eb875 10%,
          #2dbadc 20%,
          #258bcc 31%,
          #273d96 43%,
          #944496 50%,
          #bb4695 53%,
          #dc0536 65%,
          #e83a16 76%,
          #fcd475 89%,
          #d7de00 100%
        ),
        linear-gradient(#c12411, #c12411);
      position: absolute;
      left: 0;
      top: 0;
    }
    .top-l {
      > p {
        font-size: 24px;
        font-weight: normal;
        color: #999999;
      }
      > h3 {
        font-size: 24px;
        font-weight: 500;
        color: #333;
      }
    }
    .top-r {
      padding-right: 25px;
      position: relative;
      width: 308px;
      > ul {
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        > li {
          list-style: none;
          margin-right: 30px;
          font-size: 15px;
          font-weight: normal;
          color: #333333;
          padding-bottom: 3px;
          cursor: pointer; // &:last-child { // margin-right: 0; // }
          &.active {
            border-bottom: 2px solid #e83a16;
            color: #e83a16;
          }
        }
      }
      > i {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: url(../../assets/images/more.png) no-repeat;
        background-size: 100% 100%;
        &:hover {
          background: url(../../assets/images/more1.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .news-bottom {
    width: 100%;
    > ul {
      padding-left: 588px;
      position: relative;
      > li {
        list-style: none;
        border-top: 1px solid #eee;
        cursor: pointer;
        &:hover {
          .news-box {
            .b-right {
              > p {
                color: #e83a16;
              }
              > h3 {
                color: #e83a16;
              }
            }
            .b-left {
              > p {
                color: #e83a16;
              }
              > h3 {
                color: #e83a16;
              }
            }
          }
        }
        &:last-child {
          border-bottom: 1px solid #eee;
        }
        &:first-child {
          position: absolute;
          top: 0;
          left: 0;
          > img {
            width: 500px;
            height: 281px;
            margin-bottom: 28px;
          }
          .news-box {
            padding: 0;
            padding-left: 87px;
            padding-top: 10px;
            .b-right {
              width: 394px;
              padding-left: 8px;
              border-left: 1px solid #eee;
              > p {
                font-size: 14px;
                overflow: visible;
                white-space: normal;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
          }
        }
        > img {
          width: 0;
          height: 0;
        }
        .news-box {
          padding: 22px 0px 28px 120px;
          position: relative;
          padding-top: 8px;
          .b-left {
            width: 76px;

            height: 41px;
            position: absolute;
            top: 10px;
            left: 0;
            text-align: right;
            > h3 {
              font-size: 24px;
              font-weight: normal;
              color: #999999;
            }
            > p {
              font-size: 14px;
              font-weight: normal;
              color: #999999;
            }
          }
          .b-right {
            > h3 {
              font-size: 16px;
              font-weight: normal;
              color: #333333;
              margin-bottom: 6px;
              overflow: hidden; /* 超出部分隐藏 */
              white-space: nowrap;
              /* 不换行 */
              text-overflow: ellipsis;
              /* 超出部分省略号显示 */
            }
            > p {
              font-size: 14px;
              font-weight: normal;
              color: #999999;
              overflow: hidden;
              /* 超出部分隐藏 */
              white-space: nowrap;
              /* 不换行 */
              text-overflow: ellipsis;
              /* 超出部分省略号显示 */
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Index/index.vue